module.exports = "/_next/static/images/MakeInformedDecisions@2x-67c9310d62919cb57b81308477dbc78d.png";